export default __webpack_public_path__ + "static/media/mute.f5a66ea4.svg";